export default __webpack_public_path__ + "static/media/onboarding.772c6298.png";